import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { rolesService } from 'api/configuration/roles'
import { IRole } from 'interfaces/roles'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { useNotification } from 'hooks/notifications/useNotification'

interface IProps {
  role: IRole
  removeFromView: () => void | Promise<void>
  close: () => void
}

export const Remove = ({ role, removeFromView, close }: IProps) => {
  const { t } = useTranslation()
  const notification = useNotification()
  const prefix =
    'configuration.rolesAndPermissions.roles.table.actions.delete.modal'
  const [processing, setProcessing] = useState(false)

  const remove = async () => {
    setProcessing(true)
    try {
      await rolesService.removeRole(role.id)
      notification.success(t(`${prefix}.notifications.success`))
      await removeFromView()
      close()
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.errors ||
        error?.data?.errors ||
        t(`${prefix}.notifications.error`)
      notification.error(errorMessage)
    } finally {
      setProcessing(false)
    }
  }

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      isConfirmation={true}
      maxwidth={800}
      maxheight={204}
      close={close}
      actions={
        <ModalButtons
          primaryText={t(`${prefix}.buttons.delete`)}
          primaryAction={remove}
          secondaryText={t(`${prefix}.buttons.cancel`)}
          secondaryAction={close}
          processing={processing}
        />
      }
    >
      <>
        <div style={{ fontWeight: 'bold' }}>
          {t(`${prefix}.subtitle`)
            .replace('{rol}', role.name)
            .replace('{users}', role.users.toString())}
        </div>
        <div>{t(`${prefix}.description`)}</div>
        <div>{t(`${prefix}.confirmation`)}</div>
      </>
    </Modal>
  )
}

export default Remove
